var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.type == 1)?_c('FunIntro',{attrs:{"type":_vm.type,"id":_vm.id}}):_vm._e(),(_vm.type == 2)?_c('ProfessionalIntro',{attrs:{"type":_vm.type,"id":_vm.id}}):_vm._e(),_c('router-view',{})],1)}
var staticRenderFns = []

export { render, staticRenderFns }